import * as React from 'react';
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import type { } from '@mui/material/themeCssVarsAugmentation';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './AppNavbar';
import SideMenu from './SideMenu';
import AppTheme from './shared-theme/AppTheme';
import  { MenuContentProps } from './MenuContent';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';
import { MainMenu } from '../../core/config/data.types';
import { StatusAppViewProps } from '../modulos/root/root.controller';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props: {menuProps:MenuContentProps, disableCustomTheme?: boolean, propsApp:StatusAppViewProps, children: React.ReactNode }) {
  const { children,menuProps } = props;
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>

      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex', flex:1 }}>
        <SideMenu {...menuProps} />
        <AppNavbar listMenu={menuProps.listItens} propsApp={props.propsApp}  />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            display:"flex",
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              display:"flex",
              flex:1,
              alignItems: 'flex-start',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            
            {children}
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
